export default __webpack_public_path__ + "5546a4d0de9c623a1d72676dbf85a59d.svg";